import { HeadingTypeEnum } from 'common/enums/HeadingTypeEnum'

export const headingFontSize = {
  [HeadingTypeEnum.HeaderOne]: { fontSize: 40, lineHeight: 48 },
  [HeadingTypeEnum.HeaderTwo]: { fontSize: 32, lineHeight: 38.4 },
  [HeadingTypeEnum.HeaderThree]: { fontSize: 28, lineHeight: 33.6 },
  [HeadingTypeEnum.HeaderFour]: { fontSize: 24, lineHeight: 28.8 },
  [HeadingTypeEnum.HeaderFive]: { fontSize: 20, lineHeight: 24 },
  [HeadingTypeEnum.HeaderSix]: { fontSize: 16, lineHeight: 19.2 },
}

export const mobileHeadingFontSize = {
  [HeadingTypeEnum.HeaderOne]: { mobileFontSize: 30, mobileLineHeight: 36 },
  [HeadingTypeEnum.HeaderTwo]: { mobileFontSize: 24, mobileLineHeight: 28.8 },
  [HeadingTypeEnum.HeaderThree]: { mobileFontSize: 22, mobileLineHeight: 26.4 },
  [HeadingTypeEnum.HeaderFour]: { mobileFontSize: 20, mobileLineHeight: 24 },
  [HeadingTypeEnum.HeaderFive]: { mobileFontSize: 16, mobileLineHeight: 19.2 },
  [HeadingTypeEnum.HeaderSix]: { mobileFontSize: 14, mobileLineHeight: 16.8 },
}
